import { Observable } from 'rxjs';
import { User } from '@mode/algolia/contract';

export interface SearchEmailPayload {
  searchText: string;
  externalSharingEnabled: boolean;
  domains: string[];
  organization: string;
}

export abstract class EmailSearchFacade {
  public abstract searchResults$: Observable<User[]>;
  public abstract searchEmail(props: SearchEmailPayload): void;
}

export interface Emailable {
  email: string;
}
